var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M24 6H0V2h24v4zm0 4H0v4h24v-4zm0 8H0v4h24v-4z","fill":"#4C4541"}})])}
var staticRenderFns = []

export { render, staticRenderFns }